<template>
    <div>
        <!-- Modal Qockpit List -->
        <div class="modal fade" id="qockpitGetDocsModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Documentos Qockpit</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <table class="table table-sm table-hover">
                            <thead>
                                <tr>
                                    <th>
                                        <a href="#" @click.prevent="toggle_docs()">
                                            X
                                        </a>
                                    </th>
                                    <th>Id</th>
                                    <th>Documento</th>
                                    <th>Vigente</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(doc, idx) in qockpit_list" :key="idx">
                                    <td>
                                        <input type="checkbox" v-model="doc.selec">
                                    </td>
                                    <td>
                                        #{{ doc.id }}
                                    </td>
                                    <td>
                                        {{ doc.search }}
                                    </td>
                                    <td>
                                        {{ doc.vigente ? doc.vigente.version : '' }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="incluir_modelo_docs()">Incluir</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzSubmit from '../../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            qockpit_search_docs: "", 
            qockpit_list: null, 
        }
    },
    
    components: { 
        AzSubmit, 
    }, 

    methods: { 
        incluir_modelo_docs () { 
            let lista = this.qockpit_list.filter(item => item.selec);

            this.$util.atualizar(this, { 
                service: 'modelo_documentos',
                func: 'qockpit_docs_create',
                dados: { 
                    lista: lista, 
                },
                modal: 'qockpitGetDocsModal', 
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

        toggle_docs () { 
            let selec = this.qockpit_list.find(item => !item.selec) ? true : false; 

            this.qockpit_list.forEach(element => {
                element.selec = selec; 
            });
        },

        abrir () {  
            this.qockpit_search_docs = ""; 

            if ( this.qockpit_list === null ) { 
                this.$util.load(this, {
                    service: 'modelo_documentos',
                    func: 'qockpit_list', 
                    parms: { 
                        para_criar: true, 
                    }, 
                    loadTo: res => { 
                        this.qockpit_list = res.lista 
                            ? res.lista
                            : [];
                        $('#qockpitGetDocsModal').modal('show');
                    }
                });
            } else { 
                $('#qockpitGetDocsModal').modal('show');
            }
        },
    }
}
</script>
